import { WorkoutInsertModal } from './WorkoutInsertModal';

export default WorkoutInsertModal;
